import React from "react";

const SearchIcon = (props) => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.58464 18.6004C13.9569 18.6004 17.5013 15.015 17.5013 10.5922C17.5013 6.16937 13.9569 2.58398 9.58464 2.58398C5.21238 2.58398 1.66797 6.16937 1.66797 10.5922C1.66797 15.015 5.21238 18.6004 9.58464 18.6004Z"
        stroke="#D9232E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3346 19.4437L16.668 17.7578"
        stroke="#D9232E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SearchIcon;
